import React from 'react';
import { Box, Typography } from '@lucid/lego';
import styles from '../WorkspaceAccess.module.scss';
import type { User } from '../WorkspaceAccess';
import { useStore } from '../../../../store/store';

type detailsProps = {
  selectedUser: User | null;
};

const Details: React.FC<detailsProps> = ({ selectedUser }) => {
  const theme = useStore((state) => state.theme);

  if (!selectedUser) {
    return (
      <Box pt={32} pr={32} pb={24} pl={32}>
        <Typography color="white" variant="subtitle" size="medium" theme={theme} align="center">
          There is no user to view details.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box pl={16} pb={24} pt={64}>
        <Typography theme={theme} variant="headline" size="small" color="primary-1">
          {selectedUser.profileId}
        </Typography>
      </Box>
      <Box pl={16} pb={24} className={styles.scrollable}>
        <Box
          pb={24}
          pl={24}
          pr={24}
          pt={16}
          className={styles.cardBox}
          background={'white'}
          theme={theme}
        >
          <Typography color="black" variant="h2" size="medium" theme={theme}>
            Profile Details
          </Typography>
          <Box
            background="gray-1"
            pb={16}
            pl={24}
            pr={24}
            pt={16}
            mt={16}
            className={styles.cardBox}
          >
            <Box mb={12}>
              <Typography color="primary-1" size="small" variant="body">
                User Name
              </Typography>
              <Typography color="black" size="medium" variant="body">
                {selectedUser.name}
              </Typography>
            </Box>
            <Box>
              <Typography color="primary-1" size="small" variant="body">
                Email
              </Typography>
              <Typography color="black" size="medium" variant="body">
                {selectedUser.email}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          pb={16}
          pl={24}
          pr={24}
          pt={24}
          mt={16}
          className={styles.cardBox}
          background={'white'}
          theme={theme}
        >
          <Typography color="black" variant="h2" size="medium" theme={theme}>
            Workspace Access
          </Typography>
          <Box mt={16} className={styles.workspaceListContainer}>
            {selectedUser.workspaces.map((ws) => (
              <Box
                key={ws.name}
                pb={12}
                pl={12}
                pr={12}
                pt={12}
                mb={12}
                background={ws.isActive ? 'black' : 'white'}
                className={styles.cardBoxBorder}
              >
                <Typography color={ws.isActive ? 'primary-1' : 'black'} size="small" variant="body">
                  {ws.name}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Details;
